import ApplicationForm from '@scaler_landing/components/applicationForm';
import Curriculum from '@scaler_landing/components/curriculum';
import HeaderApply from '@scaler_landing/components/headerApply';

window.addEventListener('load', () => {
  ApplicationForm.initialize();
  Curriculum.initialize();
  HeaderApply.initialize();
});
